// extracted by mini-css-extract-plugin
export default {"global":"style_global__SqjY8","icon":"style_icon__qYmPt","title":"style_title__wTs2T","links":"style_links__ajkH8"};